import { render, staticRenderFns } from "./GeorepreportGrid.vue?vue&type=template&id=4d567a13"
import script from "./GeorepreportGrid.vue?vue&type=script&lang=js"
export * from "./GeorepreportGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports